import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "dashboard-content bg-white dark:bg-(--color-dark-bg-primary)" };
import { onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import { useAccountInfo } from "@/shared/composables/useAccountInfo";
import { useToast } from "@/shared/composables/useToast";
export default /*@__PURE__*/ _defineComponent({
    __name: 'Dashboard',
    setup(__props) {
        const route = useRoute();
        const router = useRouter();
        const { t } = useI18n();
        const { showSuccess } = useToast();
        const { fetchAccountInfo } = useAccountInfo();
        async function showInviteSuccess() {
            if (route.query.invite !== "1") {
                return;
            }
            const organizationName = localStorage.getItem("organizationCache");
            showSuccess(organizationName
                ? t("dashboard.transactions.inviteSuccess", { organizationName })
                : t("dashboard.transactions.inviteSuccessWithoutName"));
            const { invite: _invite, ...remainingQuery } = route.query;
            await router.replace({ query: remainingQuery });
        }
        onMounted(async () => {
            void fetchAccountInfo();
            await showInviteSuccess();
        });
        return (_ctx, _cache) => {
            const _component_router_view = _resolveComponent("router-view");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_router_view)
            ]));
        };
    }
});
